
import type { Breakpoint } from '@mui/material';
import { useIsMobile, mobileBreakpoint } from '@uplift/hooks';


interface ViewPortRenderProps {
  breakpoint?: Breakpoint;
  show?: boolean;
}

export const MobileOnly: React.FC<ViewPortRenderProps> = ({ children, breakpoint = mobileBreakpoint, show = true }): JSX.Element | null => {
  const isMobile = useIsMobile(breakpoint);

  if (!show) return null;
  return isMobile ? <>{children}</> : null;
};

export const DesktopOnly: React.FC<ViewPortRenderProps> = ({ children, breakpoint = mobileBreakpoint, show = true }): JSX.Element | null => {
  const isMobile = useIsMobile(breakpoint);

  if (!show) return null;
  return isMobile ? null : <>{children}</>;
};
